
import BaseTag from '@marketplace/components/BaseTag.vue'
import ModalQuickBuy from '@marketplace/components/modals/marketplace/ModalQuickBuy.vue'
import ThePrice from '@marketplace/components/product/the-price.vue'
import { ORDER_PRODUCT_STATUS_BADGE_MAP } from '@marketplace/config/order.js'

export default {
    name: 'ModalOrderProductDetails',

    components: {
        BaseTag,
        ThePrice,
    },

    props: {
        payload: {
            type: Object,
            default: () => {},
        },
        loadMoreProducts: {
            type: Function,
            default: () => {},
        },
        orderIndex: {
            type: Number,
            default: 0,
        },
        fetchMoreProducts: {
            type: Function,
            default: () => {},
        },
    },

    data() {
        return {
            products: [],
            hasNextPage: false,
            endCursor: null,
        }
    },

    computed: {
        isHidden() {
            return !this.products || this.products?.length === 0
        },
        storefrontName() {
            return this.payload?.storefronts?.edges?.[0]?.node?.name
        },
        isMobile() {
            return this.$breakpoint.includes('mobile')
        },

        productImages() {
            const images = {}

            this.products.forEach((product) => {
                const variantImg =
                    product?.listingVariant?.image?.transformedUrl
                const fallbackImg =
                    product?.images?.edges?.[0]?.node?.transformedUrl ||
                    require(`~/assets/images/placeholders/unavailable-product.avif`)

                images[product.id] = variantImg || fallbackImg
            })

            return images
        },
    },

    mounted() {
        this.products =
            this.payload?.products?.edges?.map((item) => item.node) || []
        this.hasNextPage =
            this.payload?.products?.pageInfo?.hasNextPage ?? false
        this.endCursor = this.payload?.products?.pageInfo?.endCursor ?? null
    },

    beforeDestroy() {
        this.products = []
        this.hasNextPage = false
        this.endCursor = null
        this.fetchMoreProducts(this.endCursor)
    },
    methods: {
        getListingId(payload) {
            const listing = payload?.listing || null
            if (
                !listing ||
                !listing.isPublished ||
                !listing?.storefront?.slug ||
                !listing?.storefront?.isPublished ||
                listing?.isOrderWriterOnly ||
                !payload?.canBeReordered
            )
                return ''
            return payload?.listing?.databaseId || ''
        },
        getListingStorefrontSlug(payload) {
            return payload?.listing?.storefront?.slug
        },
        async loadMoreHandler() {
            const tempProductDetails = (
                await this.loadMoreProducts(this.hasNextPage, this.endCursor)
            )?.data?.order?.supplierOrders?.edges?.[this.orderIndex]?.node
                ?.products

            if (!tempProductDetails) {
                return
            }

            const newProducts =
                tempProductDetails?.edges?.map((item) => item.node) || []
            this.hasNextPage =
                tempProductDetails?.pageInfo?.hasNextPage ?? false
            this.endCursor = tempProductDetails?.pageInfo?.endCursor ?? null
            this.products = [...this.products, ...newProducts]
        },
        getFirstImage(payload) {
            if (payload?.images?.edges?.[0]?.node?.transformedUrl) {
                return payload?.images?.edges?.[0]?.node?.transformedUrl
            } else {
                return require(`~assets/images/placeholders/unavailable-product.avif`)
            }
        },

        openQuickBuyModal(storefrontSlug, listingId) {
            this.$vfm.show({
                component: ModalQuickBuy,
                bind: {
                    storefrontSlug,
                    listingId,
                    trackingCategory: 'Order Detail Page',
                },
            })
        },
        orderProductStatusDelayed(status) {
            return status.toLowerCase() === 'delayed'
        },
        getOrderProductStatusColor(status) {
            return ORDER_PRODUCT_STATUS_BADGE_MAP?.[status.toLowerCase()]
        },
        getOrderProductStatusLabel(status) {
            if (!status) {
                return this.$t('labels.to_be_shipped')
            }

            return this.$t(`labels.${status.toLowerCase()}`)
        },
    },
}
